import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { EmailVerificationTemplate } from '../../components/Templates';
import { ResetPasswordResult } from '../../models/UserStore/UserStore';
import { useUserStore } from '../../stores/UserStore';
import { useShareData } from '../../context';

const { verifyEmail } = useUserStore.getState();

const EmailVerificationScreen: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { setSharedData } = useShareData();

  useEffect(() => {
    setSharedData(undefined);
  }, [setSharedData]);

  const [success, setSuccess] = useState<boolean>();

  useEffect(() => {
    const verifyEmailFn = async () => {
      const queryParams = new URLSearchParams(location.search);
      const email = queryParams.get('email');
      const token = queryParams.get('token');

      const fallbackEmail = new URLSearchParams(
        new URL(window.location.href).search,
      )
        .get('email')
        ?.replace(/ /g, '+');

      const finalEmail = email?.includes(' ') ? fallbackEmail : email;

      if (finalEmail && token) {
        const res = await verifyEmail({ email: finalEmail, token });
        if (res === ResetPasswordResult.Success) {
          setSuccess(true);
        } else {
          setSuccess(!!success && false);
        }
      } else {
        setSuccess(!!success && false);
      }
    };

    verifyEmailFn().catch(console.error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, navigate]);

  // MARK: if user click the link for a 2nd time, still show them the same page again.
  // useEffect(() => {
  //   if (success === false) {
  //     navigate('/');
  //   }
  // }, [navigate, success]);

  return <EmailVerificationTemplate />;
};

export default EmailVerificationScreen;
